import { Input } from "@/components/ui/input";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { FileText, X } from "lucide-react";
import { Control, FieldPath, FieldValues } from "react-hook-form";

interface TermsAndConditionsFieldProps<T extends FieldValues> {
  control: Control<T>;
  name: FieldPath<T>;
  edit?: boolean;
  showSeparator?: boolean;
}

export function TermsAndConditionsField<T extends FieldValues>({
  control,
  name,
  edit = true,
}: TermsAndConditionsFieldProps<T>) {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium flex items-center gap-2">
        <FileText className="h-4 w-4" />
        Terms and Conditions {edit ? "" : "(Optional)"}
      </h3>

      <FormField
        control={control}
        name={name}
        render={({ field }) => (
          <FormItem>
            <FormLabel>Terms and Conditions URL</FormLabel>
            <FormControl>
              <div className="relative">
                <Input type="url" {...field} />
                {field.value && (
                  <button
                    type="button"
                    onClick={() => field.onChange("")}
                    className="absolute right-2 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground hover:text-foreground transition-colors"
                    aria-label="Clear URL"
                  >
                    <X className="h-4 w-4" />
                  </button>
                )}
              </div>
            </FormControl>
            <FormDescription>
              Set the terms and conditions URL for this sale.
              Leave empty {edit ? "to remove." : "if no terms apply."}
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
